var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-element",class:{
    'element--no-value': !_vm.resolvedValue,
  }},[_c('ABHeading',{style:(_vm.getStyleOverride('typography')),attrs:{"level":_vm.element.level}},[_vm._v("\n    "+_vm._s(_vm.element.value
        ? _vm.resolvedValue ||
          (_vm.mode === 'editing' ? _vm.$t('headingElement.emptyValue') : ' ')
        : _vm.$t('headingElement.missingValue'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }